import { CustomInput } from 'components/custom';
import React, { useEffect, useState } from 'react';

type LeaveProfileGeneralProps = {
  addData?: (data) => void;
  data?: any;
  finalData?: any;
  errorName?: any;
};

const LeaveProfileGeneral = ({ addData, data, errorName, finalData }: LeaveProfileGeneralProps) => {
  const [checkFlag, setCheckFlag] = useState(false);
  useEffect(() => {
    if (data?.french_description?.length > 0 || data?.french_long_description?.length > 0 || data?.french_comment?.length > 0) {
      setCheckFlag(true);
    }
  }, []);
  const handleClick = () => {
    if (!data) {
      setCheckFlag(!checkFlag);
    }
  }
  return (
    <div style={{ marginTop: '90px' }}>
      <section className={'function_container'}>
        <div
          style={{ background: 'white', padding: 0 }}
          className={'function_wrapper'}
        >
          <div>
            <div style={{ marginTop: '20px', paddingTop: 32, paddingLeft: 32 }}>
              <CustomInput
                maxLength={70}
                background={data ? '#f5f5f5' : ''}
                disabled={data}
                value={data ? data?.name : finalData?.name}
                onChange={(e) => addData({ name: e?.target?.value })}
                title="Name"
                required
                error={errorName as string}
                fontSize={12}
              />
            </div>
            <h2
              style={{
                padding: "32px 0px 16px 32px",
                fontWeight: 500,
                fontSize: 20,
              }}
            >
              Descriptions
            </h2>
            <div
              className={'add_user_fourth_step_table_header'}
              style={{ display: 'flex', justifyContent: 'start' }}
            >
              <div
                style={{ width: '15%' }}
                className={'add_user_fourth_step_table_header'}
              >
                Languages
              </div>
              <div
                style={{ width: '20%' }}
                className={'add_user_fourth_step_table_header'}
              >
                Description
              </div>
              <div
                style={{ width: '20%' }}
                className={'add_user_fourth_step_table_header'}
              >
                Long description
              </div>
              <div
                style={{ width: '20%' }}
                className={'add_user_fourth_step_table_header'}
              >
                Comments
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                gap: 10,
                padding: '10px 10px 10px 20px',
              }}
            >
              <div
                style={{
                  width: '15%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img
                  src="/assets/eng.svg"
                  alt="flag"
                  style={{ cursor: 'pointer' }}
                />
              </div>

              <input
                maxLength={70}
                value={data?.description}
                disabled={data}
                onChange={(e) => addData({ description: e?.target?.value })}
                className="common_custom_input_search"
                style={{ fontSize: '12px', width: '20%', background: data ? '#f5f5f5' : '', border: data && 'none', cursor: data ? 'not-allowed' : 'pointer', }}
              />
              <input
                maxLength={70}
                value={data?.long_description}
                disabled={data}
                onChange={(e) =>
                  addData({ long_description: e?.target?.value })
                }
                className="common_custom_input_search"
                style={{ fontSize: '12px', width: '20%', background: data ? '#f5f5f5' : '', border: data && 'none', cursor: data ? 'not-allowed' : 'pointer', }}
              />
              <input
                maxLength={70}
                value={data?.comment}
                disabled={data}
                onChange={(e) => addData({ comment: e?.target?.value })}
                className="common_custom_input_search"
                style={{ fontSize: '12px', width: '20%', background: data ? '#f5f5f5' : '', border: data && 'none', cursor: data ? 'not-allowed' : 'pointer', }}
              />
              <div style={{
                width: '19%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end'
              }}>
                <img
                  onClick={handleClick}
                  src="/icons/flag.svg"
                  alt="flag"
                  style={{ cursor: data ? 'not-allowed' : 'pointer', marginLeft: '15%' }}
                />
              </div>
            </div>
            {checkFlag && <div
              style={{
                display: 'flex',
                gap: 10,
                padding: '10px 10px 10px 20px',
              }}
            >
              <div
                style={{
                  width: '15%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img
                  src="/icons/france.svg"
                  alt="flag"
                  style={{ cursor: 'pointer' }}
                />
              </div>

              <input
                maxLength={70}
                value={data?.french_description}
                disabled={data}
                onChange={(e) => addData({ french_description: e?.target?.value })}
                className="common_custom_input_search"
                style={{ fontSize: '12px', width: '20%', background: data ? '#f5f5f5' : '', border: data && 'none', cursor: data ? 'not-allowed' : 'pointer', }}
              />
              <input
                maxLength={70}
                value={data?.french_long_description}
                disabled={data}
                onChange={(e) =>
                  addData({ french_long_description: e?.target?.value })
                }
                className="common_custom_input_search"
                style={{ fontSize: '12px', width: '20%', background: data ? '#f5f5f5' : '', border: data && 'none', cursor: data ? 'not-allowed' : 'pointer', }}
              />
              <input
                maxLength={70}
                value={data?.french_comment}
                disabled={data}
                onChange={(e) => addData({ french_comment: e?.target?.value })}
                className="common_custom_input_search"
                style={{ fontSize: '12px', width: '20%', background: data ? '#f5f5f5' : '', border: data && 'none', cursor: data ? 'not-allowed' : 'pointer', }}
              />
              <div style={{
                width: '19%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end'
              }}>
                <img
                  src="/icons/flag.svg"
                  alt="flag"
                  style={{ marginLeft: '15%' }}
                />
              </div>
            </div>
            }

          </div>
        </div>
      </section>
    </div>
  );
};

export default LeaveProfileGeneral;
